import { CommonModule } from '@angular/common';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { GestorContenidoService } from 'src/app/services/gestor-contenido.service';
import { ContactoAtencionInfoComponent } from 'src/app/shared/components/contacto-atencion-info/contacto-atencion-info.component';
import {
  ContactoAtencionKind,
  getContactoAtencionContent,
} from 'src/app/shared/data/contacto-atencion.content';

export type HomeFooterInfoModalKind = ContactoAtencionKind;

export interface HomeFooterCmsLogo {
  imagen: string;
  url: string;
  alt: string;
}

@Component({
  selector: 'app-home-site-footer',
  templateUrl: './home-site-footer.component.html',
  styleUrls: ['./home-site-footer.component.scss'],
  standalone: true,
  imports: [CommonModule, ContactoAtencionInfoComponent],
})
export class HomeSiteFooterComponent implements OnInit {
  /** Si true, no llama CMS/back y no muestra logos institucionales. */
  @Input() skipCms = false;

  logos: HomeFooterCmsLogo[] = [];
  modalOpen = false;
  modalKind: HomeFooterInfoModalKind | null = null;
  modalTitle = '';

  constructor(private readonly gestorContenido: GestorContenidoService) {}

  ngOnInit(): void {
    if (!this.skipCms) {
      this.loadLogosFooter();
    }
  }

  openInfoModal(kind: HomeFooterInfoModalKind): void {
    this.modalKind = kind;
    this.modalTitle = getContactoAtencionContent(kind).title;
    this.modalOpen = true;
  }

  closeInfoModal(): void {
    this.modalOpen = false;
    this.modalKind = null;
    this.modalTitle = '';
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.modalOpen) {
      this.closeInfoModal();
    }
  }

  /**
   * Logos institucionales desde CMS (`/cms/logosFooter/buscarTodos`).
   * Orden: tal cual llega del back/Drupal — la View ordena por título alfabético
   * (p. ej. Bancóldex, Colombia, Fintech, Veritas). Sin campo `orden` en el contrato.
   * No aplicar sort aquí.
   */
  private loadLogosFooter(): void {
    this.gestorContenido.getLogosFooter(0).subscribe({
      next: (response: { rows?: unknown[] }) => {
        this.logos = this.mapCmsLogos(response?.rows);
      },
      error: () => {
        this.logos = [];
      },
    });
  }

  private mapCmsLogos(rows: unknown[] | undefined): HomeFooterCmsLogo[] {
    if (!Array.isArray(rows) || !rows.length) {
      return [];
    }

    return rows
      .map((row) => {
        const item = row as {
          imagen?: string;
          url?: string;
          titulo?: string;
          descripcion?: string;
        };
        const imagen = item.imagen?.trim();
        if (!imagen) {
          return null;
        }
        return {
          imagen,
          url: item.url?.trim() ?? '',
          alt: item.descripcion?.trim() || item.titulo?.trim() || 'Logo institucional',
        } satisfies HomeFooterCmsLogo;
      })
      .filter((logo): logo is HomeFooterCmsLogo => logo !== null);
  }
}
